import React from 'react';
import { Drawer } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import {
  CalendarOutlined,
  QrcodeOutlined,
  UserOutlined
} from '@ant-design/icons';
import { useSidebar } from '../../../hooks/useSidebar';
import './Sidebar.css';

const Sidebar = () => {
  const { isOpen, closeSidebar } = useSidebar();
  const location = useLocation();

  const handleLinkClick = () => {
    closeSidebar();
  };

  return (
    <Drawer
      title={null}
      placement="left"
      onClose={closeSidebar}
      open={isOpen}
      width={306}
      closable={false}
      bodyStyle={{
        padding: 0,
        backgroundColor: '#FDFDFD',
      }}
      headerStyle={{
        display: 'none'
      }}
      className="sidebar-drawer"
    >
      <div className="sidebar-main-container">
        <div className="sidebar-column-layout">
          {/* Top border */}
          <div className="sidebar-top-line"></div>
          
          {/* Main content container */}
          <div className="sidebar-content-container">
            {/* Sidebar Title */}
            <div className="sidebar-title-container">
              <h2 className="sidebar-title">Menu</h2>
            </div>
            
            {/* Calendar Menu Item */}
            <Link 
              to="/calendar"
              className={`sidebar-menu-item ${location.pathname === '/calendar' ? 'selected' : ''}`}
              onClick={handleLinkClick}
            >
              <div className="sidebar-menu-content">
                <div className="sidebar-icon">
                  <CalendarOutlined 
                    style={{
                      fontSize: '20px',
                      color: location.pathname === '/calendar' ? '#D16620' : '#333333'
                    }}
                  />
                </div>
                <span className="sidebar-menu-text">Calendar</span>
              </div>
            </Link>

            {/* Income Menu Item */}
            <Link 
              to="/income"
              className={`sidebar-menu-item ${location.pathname === '/income' ? 'selected' : ''}`}
              onClick={handleLinkClick}
            >
              <div className="sidebar-menu-content">
                <div className="sidebar-icon">
                  <QrcodeOutlined 
                    style={{
                      fontSize: '22px',
                      color: location.pathname === '/income' ? '#D16620' : '#333333'
                    }}
                  />
                </div>
                <span className="sidebar-menu-text">Income</span>
              </div>
            </Link>

            {/* Profile Menu Item */}
            <Link 
              to="/profile"
              className={`sidebar-menu-item ${location.pathname === '/profile' ? 'selected' : ''}`}
              onClick={handleLinkClick}
            >
              <div className="sidebar-menu-content">
                <div className="sidebar-icon">
                  <UserOutlined 
                    style={{
                      fontSize: '20px',
                      color: location.pathname === '/profile' ? '#D16620' : '#333333'
                    }}
                  />
                </div>
                <span className="sidebar-menu-text">Profile</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default Sidebar;